import {instance} from "../fetch";
import {API_URL} from "../../constants/axios";

/**
 * 사업자번호 확인 고유링크(로그인 없이 쓰는 카드 등록) API.
 *
 * ⚠️ **`fetchApi` 가 아니라 `instance` 를 쓴다.** `fetchApi` 는 요청마다 토큰 헤더를 붙이고
 * 401 을 로그인 화면으로 돌린다. 이 화면들은 **로그인하지 않은 고객**이 여는 곳이라
 * 그 처리에 걸리면 안 된다. 제거된 구 링크(`requestTossBillingDirect`)도 같은 이유로 `instance` 를 썼다.
 *
 * 설계: `_ai-runs/2026-09-07_002_install_wizard/011_round5_card_link.md`
 */

/** 링크가 유효한가 + 업체명. 🔴 사업자등록번호는 응답에 담기지 않는다(맞혀야 하는 값이다). */
export const getCardLinkInfo = async (token) => {
    const res = await instance.get(`${API_URL.CARD_LINK_INFO}?token=${encodeURIComponent(token)}`);
    return res.data;
};

/** 사업자등록번호 확인. 통과하면 `data.ticket`(1회용) 을 준다. */
export const verifyCardLink = async (token, bizRegNumber) => {
    const res = await instance.post(API_URL.CARD_LINK_VERIFY, {token, bizRegNumber});
    return res.data;
};

/**
 * 토스 콜백 → 빌링키 발급. 계정은 서버가 **티켓에서** 꺼낸다(URL 에 없다).
 *
 * @param setDefault 고객이 확인창에서 '네' 를 눌렀는가(2026-09-10).
 *   🔴 `false` 가 "기본이 되지 않는다" 는 뜻은 아니다 — 살아 있는 기본카드가 없으면
 *   서버가 이 카드를 기본으로 만든다(카드는 있는데 기본이 없는 상태를 만들지 않는다).
 */
export const registerCardByLink = async (customerKey, authKey, ticket, setDefault = false) => {
    const res = await instance.get(
        `${API_URL.TOSS_BILLING_LINK}?customerKey=${encodeURIComponent(customerKey)}`
        + `&authKey=${encodeURIComponent(authKey)}&ticket=${encodeURIComponent(ticket)}`
        + `&setDefault=${setDefault ? 'true' : 'false'}`
    );
    return res.data;
};
